import React, { useState, useEffect } from 'react';
import { Button } from 'aha-components';
import ModalAnalysisBreadcrumb from '../ModalAnalysisBreadcrumb';
import AudienceDemographics from './audienceDemographics';
import AnalysisContent from './AnalysisContent';
import PriceContent from './PriceContent';
import { AudienceViewSource, SelfEstimatedStatus } from './config';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import { useTranslation } from 'react-i18next';
import { scrollElementToTop } from '@/utils/scrollElementToTop';
import {
  ProductType,
  ProductPhysicalSelectEnum
} from '@/components/web/config';

interface Props {}

// 接单流程 移动端弹窗内容

const MobileConst: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const { order, audienceView, product } = detailData || {};
  const [step, setStep] = useState(1);
  const {
    thisLoading,
    setShowModalTakeOrder,
    productShippingCountry,
    agreeProductShip
  } = useWebModalStore();
  const { screeningQuestions } = useMultiplePricesStore();
  const [hasAudienceData, setHasAudienceData] = useState(false); // 集合订单详情中的，和弹窗内轮询/获取到的数据
  const [audienceError, setAudienceError] = useState(false); // 判断是否报错
  const [selectCountryError, setSelectCountryError] = useState(false); // 判断是否选择国家

  const isProductShip =
    product?.productType === ProductType.PHYSICAL_PRODUCT &&
    product?.physicalProductShipType === ProductPhysicalSelectEnum.ship;

  useEffect(() => {
    if (
      audienceView?.source === AudienceViewSource.FIRST_PARTY ||
      (audienceView?.status === SelfEstimatedStatus.SUCCESS &&
        audienceView?.source === AudienceViewSource.SELF_ESTIMATED)
    ) {
      setHasAudienceData(true);
    }
  }, [audienceView]);

  const isScreeningQuestionsIncomplete =
    !!screeningQuestions?.length &&
    screeningQuestions.some((question) => !question?.answer?.trim());

  useEffect(() => {
    // // 是一方平台数据；或者是自研数据 并且数据已经准备好；并且不是本次上传截图的信息，则跳到步骤2,
    if (
      (audienceView?.source === AudienceViewSource.FIRST_PARTY ||
        (audienceView?.status === SelfEstimatedStatus.SUCCESS &&
          audienceView?.source === AudienceViewSource.SELF_ESTIMATED)) &&
      !thisLoading
    ) {
      setStep(2);
    } else {
      setStep(1);
    }
  }, [audienceView]);

  const mobileStickyFooterClassName =
    'bg-white w-full fixed bottom-0 left-0 right-0 z-[1301] flex gap-2 border-t border-solid border-[#e8e8ec] px-4 pt-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))]';
  const mobileStepContentClassName =
    'pb-[calc(88px+env(safe-area-inset-bottom,0px))]';

  return (
    <>
      {/* 步骤 */}
      <ModalAnalysisBreadcrumb index={step - 1} />

      {/* 步骤内容 */}
      <div className="mt-4">
        {step === 1 && (
          <>
            {/* 步骤1 */}
            <div className={mobileStepContentClassName}>
              <AudienceDemographics
                audienceError={audienceError}
                setAudienceError={setAudienceError}
                setHasAudienceData={setHasAudienceData}
              />
            </div>
            <div className={mobileStickyFooterClassName}>
              <Button
                className="flex-1"
                onClick={() => setShowModalTakeOrder(false)}
              >
                <span>
                  {t('general_text.cancel', {
                    defaultValue: 'Cancel'
                  })}
                </span>
              </Button>
              <Button
                type="primary"
                className="flex-1"
                onClick={() => {
                  if (hasAudienceData) {
                    setStep(step + 1);
                  } else {
                    setAudienceError(true);
                  }
                }}
              >
                <span>
                  {t('general_text.continue', {
                    defaultValue: 'Continue'
                  })}
                </span>
              </Button>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            {/* 步骤2 */}
            <div className={mobileStepContentClassName}>
              <AnalysisContent
                selectCountryError={selectCountryError}
                setSelectCountryError={setSelectCountryError}
              />
            </div>
            <div className={mobileStickyFooterClassName}>
              <Button className="flex-1" onClick={() => setStep(1)}>
                <span>
                  {t('general_text.back', {
                    defaultValue: 'Back'
                  })}
                </span>
              </Button>
              <Button
                type="primary"
                className="flex-1"
                disabled={isScreeningQuestionsIncomplete}
                onClick={() => {
                  if (!agreeProductShip && isProductShip) {
                    setSelectCountryError(true);
                    scrollElementToTop('take-order-shipping-country');
                  } else {
                    setStep(3);
                  }
                }}
              >
                <span>
                  {t('general_text.continue', {
                    defaultValue: 'Continue'
                  })}
                </span>
              </Button>
            </div>
          </>
        )}
        {step === 3 && (
          <>
            {/* 步骤3 */}
            <PriceContent
              setSelectCountryError={() => {}}
              setAudienceError={() => {}}
              step={step}
              setStep={setStep}
            />
          </>
        )}
      </div>
    </>
  );
};

export default MobileConst;
